
import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';

import FormulationProduct1 from '../../icon/FormulationProduct1.jpg';
import FormulationProduct2 from '../../icon/FormulationProduct2.jpg';
import FormulationProduct3 from '../../icon/FormulationProduct3.jpg';
import FormulationProduct4 from '../../icon/FormulationProduct4.jpg';
import FormulationProduct5 from '../../icon/FormulationProduct5.jpg';

const images = [
  FormulationProduct1,
  FormulationProduct2,
  FormulationProduct3,
  FormulationProduct4,
  FormulationProduct5,
];

const FormulationSlider: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState<'forward' | 'backward'>('forward');

  // Auto slide: forward then reverse
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (direction === 'forward') {
          if (prevIndex === images.length - 1) {
            setDirection('backward');
            return prevIndex - 1;
          } else {
            return prevIndex + 1;
          }
        } else {
          if (prevIndex === 0) {
            setDirection('forward');
            return prevIndex + 1;
          } else {
            return prevIndex - 1;
          }
        }
      });
    }, 3000);
    return () => clearInterval(interval);
  }, [direction]);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentIndex(parseInt(event.target.value));
  };

  const getStyle = (index: number) => {
    const diff = index - currentIndex;
    const scale = index === currentIndex ? 1 : 0.7;
    const zIndex = index === currentIndex ? 2 : 1;
    const opacity = index === currentIndex ? 1 : 0.5;
    const translateX = diff * 120;

    return {
      transform: `translateX(${translateX}%) scale(${scale})`,
      opacity,
      zIndex,
    };
  };

  return (
    <Box py={6} sx={{ background: "#EEF0FF", position: 'relative' }} height={"400px"}>
      <Container>
        <Box
          sx={{
            position: 'relative',
            height: 300,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
           overflow:"hidden"
          }}
        >
          {images.map((src, index) => (
            <Box
              key={index}
              sx={{
                position: 'absolute',
                transition: 'all 0.6s ease',
                borderRadius: 4,
                overflow: 'hidden',
                boxShadow: index === currentIndex ? 5 : 1,
                width: 200,
                height: 250,
                ...getStyle(index),
              }}
            >
              <img
                src={src}
                alt={`formulation-${index}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ))}
        </Box>

        {/* Radio buttons (dots) */}
        <RadioGroup
          row
          value={currentIndex.toString()}
          onChange={handleRadioChange}
          sx={{ justifyContent: 'center', mt: 3 }}
        >
          {images.map((_, index) => (
            <FormControlLabel
              key={index}
              value={index.toString()}
              control={
                <Radio
                  sx={{
                    p: 0.5,
                    color: 'grey.400',
                    '&.Mui-checked': {
                      color: '#2c3e50',
                    },
                  }}
                />
              }
              label=""
            />
          ))}
        </RadioGroup>
      </Container>
    </Box>
  );
};

export default FormulationSlider;

